// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"4ef0b249371c33309d04","147":"e1f3508fadab982d5966","251":"75f0cd0153befb0e734c","352":"1663372f4e889743d547","544":"da2e9679d2efe0ea37eb"}[chunkId] + ".js";
};